import { Box, Stack, Text } from "@mantine/core";
import { SectorCardsGrid } from "@/pages/home/SectorCardsGrid";
import type { SectorCard } from "@/pages/home/sectorCatalog";
import DiscoverSectorMarquee from "@/pages/discover/components/DiscoverSectorMarquee";

type DiscoverGlobalEcosystemsSectionProps = {
  onSectorSelect?: (sector: SectorCard) => void;
  mt?: number | string;
  mb?: number | string;
};

export default function DiscoverGlobalEcosystemsSection({
  onSectorSelect,
  mt = "xs",
  mb = "lg",
}: DiscoverGlobalEcosystemsSectionProps) {
  return (
    <Box mt={mt} mb={mb} data-discover-tour="ecosystems">
      <Stack gap={0}>
        <Text fw={700} c="primary.7" ta="center">
          Explore Global Ecosystems
        </Text>
        <Box visibleFrom="sm">
          <SectorCardsGrid onSectorSelect={onSectorSelect} />
        </Box>
        <Box hiddenFrom="sm">
          <DiscoverSectorMarquee onSectorSelect={onSectorSelect} />
        </Box>
      </Stack>
    </Box>
  );
}
